import { createContext, useContext } from "react";
import { URL_API } from "../config/default";
import { myHeaders } from "../config/axios";
import { useQuery } from "@tanstack/react-query";

// Crear el contexto
const AdminContext = createContext({} as any);

export const AdminProvider = ({ children }: any) => {
  const { data: banners } = useQuery({
    queryKey: ["public-banners"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      const params = new URLSearchParams({ status: "activo" });

      return fetch(`${URL_API}/banners?${params}`, {
        method: "GET",
        headers: {
          Authorization: myHeaders,
        },
      }).then((res) => res.json());
    },
  });

  const { data, error } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const token = localStorage.getItem("token");
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      if (token) {
        return fetch(`${URL_API}/auth/me`, {
          method: "GET",
          headers: {
            Authorization: myHeaders,
          },
        }).then((res) => {
          if (!res.ok) {
            localStorage.removeItem("token");
            throw new Error("Error en la API");
          }
          return res.json();
        }).catch(() => {
          throw new Error("Error en la API");
        });
      }

      throw new Error("Error en la API");
    },
  });

  if (error) {
    return (window.location.href = "/login");
  }

  return (
    <AdminContext.Provider value={{ me: data?.data, banners: banners?.data }}>
      {children}
    </AdminContext.Provider>
  );
};

// Hook para consumir el contexto fácilmente
export const useAdminContext = () => {
  return useContext(AdminContext);
};
